export const Declaration = () => `
<h5 style="margin-bottom: 6px; page-break-after: avoid; break-after: avoid;">
  Declaration & Confirmation
</h5>

<style>
  .declaration-wrap {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .declaration-wrap ol {
    margin-top: 10px;
    padding-left: 20px;
  }
  .declaration-item {
    margin-bottom: 10px;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .declaration-item p {
    page-break-inside: avoid;
    break-inside: avoid;
  }
</style>

<div class="declaration-wrap">

  <p><strong>I hereby declare and confirm the following:</strong></p>

  <ol>

    <li class="declaration-item">
      <strong>No Conflict of Interest</strong>
      <p>
        Neither I nor any employee or direct relation of any employee of Hypermax City Private Limited
        is in any way connected as a partner, shareholder, director, advisor, consultant, or employee
        with the Company. I am not personally related to any Employee, Officer, or Director of Hypermax
        City Private Limited. I do not have any conflict of interest in entering into a contract or
        association with the Company.
      </p>
    </li>

    <li class="declaration-item">
      <strong>Compliance and Undertaking</strong>
      <p>
        I have taken note of the Code of Conduct and the Whistle Blower Policy of the Company and
        undertake to inform the Company, without delay, in case of any potential conflict of interest
        or breach of the Code of Conduct in the future.
      </p>
    </li>

    <li class="declaration-item">
      <strong>Waiver of Claims</strong>
      <p>
        I irrevocably agree to waive any and all claims, demands, suits, actions, causes of action,
        and rights whatsoever at law or in equity, now existing or arising, relating to any accrued
        and unpaid interest on delayed payments against our invoices or any other agreement with your
        Company.
      </p>
      <p>
        I further acknowledge and agree that I shall not commence or prosecute in any way, or cause
        to be commenced or prosecuted, any action in any court relating to any such accrued and unpaid
        interest.
      </p>
    </li>

    <li class="declaration-item">
      <strong>Accuracy of Information</strong>
      <p>
        The information furnished is correct to the best of my knowledge and belief.
      </p>
    </li>

  </ol>

  <div style="margin-top: 20px; page-break-inside: avoid; break-inside: avoid;">
    <p style="margin-bottom: 8px;">
      <strong>Acceptance:</strong>
    </p>
    <p style="margin-bottom: 6px; page-break-inside: avoid; break-inside: avoid;">
      <input
        type="checkbox"
        checked
        style="width: 14px; height: 14px; vertical-align: middle;"
      />
      <span style="margin-left: 6px; vertical-align: middle;">
        I have read and agree to the Terms & Conditions.
      </span>
    </p>
  </div>

</div>
`;